window.OSM = window.OSM ?? {};
/**
 * @type {IMapsProps}
 */
OSM.MapConfigs = OSM.MapConfigs ?? {}

/**
 * @type {IMapProps}
 */
OSM.MapConfigs.core = {
    preferredMapFocusOrder: ["cluster", "primary_marker", "country", "user", "defined", "default"],
    mapOptions: {
        container: "",
        style: 'https://tiles.openfreemap.org/styles/liberty',
        center: [-0.09, 51.505],
        zoom: 4,
        attributionControl: {
            compact: true
        }
    },
    primaryMarker: {
        lngLat: [0, 0],
        centreOnClick: false,
        iconProps: {
            color: "#dc3b4e",
            innerColor: "#FFFFFF",
            strokeColor: "#000000"
        },
        defaultZIndex: 4,
        defaultZoomLevel: 10
    },
    userMarker: {
        popupContent: "Your Location",
        centreOnClick: false,
        iconProps: {
            color: "#3bbedc",
            innerColor: "#FFFFFF",
            strokeColor: "#000000"
        },
        defaultZIndex: 5
    },
    cluster: {
        layer: {
            id: 'clusters',
            source: 'mapCluster',
            type: 'circle',
        },
        source: {
            clusterMaxZoom: 14,
            clusterRadius: 40,
            cluster: true,
            type: 'geojson',
            data: '',
        },

        marker: {
            lngLat: [0, 0],
            centreOnClick: false,
            iconProps: {
                color: "#7b3bdc",
                innerColor: "#FFFFFF",
                strokeColor: "#000000",
            },
            defaultZIndex: 3
        },
        clusterIcon: {
            /**
             *
             * @param itemCount {number}
             */
            getColor: (itemCount) =>
            {
                if(itemCount >= 10){
                    return "#f8dd62"
                }
                return "rgb(86,127,225)"
            },
            /**
             *
             * @param itemCount {number}
             */
            getStrokeColor: (itemCount) =>
            {
                if(itemCount >= 10){
                    return "#c5b264"
                }
                return "rgb(81 108 170)"
            },
            /**
             *
             * @param itemCount {number}
             */
            getTextColor: (itemCount) =>
            {
                if(itemCount >= 10){
                    return "#494229"
                }
                return "#ffffff"
            },
            /**
             *
             * @param itemCount {number}
             */
            getItemCountAbbreviated(itemCount) {
                if(itemCount >= 100){
                    return "99+"
                }
                return itemCount.toString();
            }
        },
        zIndex: 1,
        buttonZIndex: 2,
        withUser: false,
        withPrimaryMarker: true,
        sortByNorthWest: true,
        transitionOnClusterChange: true
    },
    geolocateControl:{
        position: "top-left",
    },
    fullscreenControl:{
        position: "top-left",
    },
    navigationControl:{
        position: "top-left",
    },
    scaleControl:{
        position: "top-left",
    },
    enableContextMenu: true,
    limitFlyToCurve: 1,
    popup: {
        closeOnMapClick: true,
        closeOnEscape: true,
        preventDefaultScroll: true
    },
    singleMarkerIsPrimaryMarker: true
}